import { useAbTest } from 'ab-test/hooks/useAbTest/useAbTest'
import { AbTestKeys } from 'types/constants/AbTestKeys'

export const useNewSearchTestAb = () => {
	const newSearchUi = useAbTest({
		key: AbTestKeys.NewSearchUi,
	})

	return {
		isNewSearchTestAbEnabled: !!newSearchUi?.enabled,
		isSearchTestAbReady: newSearchUi !== undefined,
	}
}
